import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Typography, Stack } from "@mui/material";
import HyroDialog from "@hyro-components/Dialogs/HyroUiDialog";
import HyroField from "@hyro-components/fields/HyroField";
import { FIELD_TYPES } from "@hyro-components/fields/utils";
import HyroFeedbackMessage from "@hyro-components/HyroFeedbackMessage";
import { MAX_CONTEXT_LENGTH, REASON_OPTIONS, LABELS, PLACEHOLDERS, BUTTON_TEXT, SUCCESS_MESSAGES, ERROR_MESSAGES } from "./RequestAccessDialog.consts";
import { useGetAccessForAccount } from "src/queries/hooks/accounts";

const RequestAccessDialog = ({ open, onClose, onCloseSuccess = () => window.location.reload() }) => {
  const { accountId } = useParams();
  const [reason, setReason] = useState("");
  const [context, setContext] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);
  const [feedbackConfig, setFeedbackConfig] = useState({ message: "", severity: "error", show: false });

  const { mutate: getAccessForAccount, isPending: loading } = useGetAccessForAccount({
    onSuccess: () => {
      setShowSuccess(true);
    },
    onError: () => {
      setFeedbackConfig({
        message: ERROR_MESSAGES.SUBMIT_FAILED,
        severity: "error",
        show: true
      });
    }
  });

  const handleSubmit = () => {
    getAccessForAccount({ accountId, reason, context });
  };

  const handleClose = () => {
    onClose();
    onCloseSuccess();
  };

  if (showSuccess) {
    return (
      <HyroDialog
        open={open}
        title={SUCCESS_MESSAGES.TITLE}
        variant="transactional"
        handleClose={handleClose}
        handleSubmit={handleClose}
        submitButtonText={BUTTON_TEXT.CLOSE}
        showCancelButton={false}
        showSaveButton={true}
        testId="request-access-success-dialog"
      >
        <Typography variant="body1" color="primary[500]" mt={1}>
          {SUCCESS_MESSAGES.DESCRIPTION}
        </Typography>
      </HyroDialog>
    );
  }

  return (
    <>
      <HyroDialog
        open={open}
        title={`Request access to ${accountId}`}
        variant="transactional"
        handleClose={handleClose}
        handleCancel={handleClose}
        handleSubmit={handleSubmit}
        submitButtonText={BUTTON_TEXT.SUBMIT}
        submitButtonLoading={loading}
        disableSave={!reason}
        testId="request-access-dialog"
        showCloseButton
      >
        <Stack spacing={3} mt={2}>
          <HyroField
            fieldType={FIELD_TYPES.CHOOSE_ONE}
            label={LABELS.REASON_FOR_ACCESS}
            placeholder={PLACEHOLDERS.SELECT_REASON}
            options={REASON_OPTIONS}
            value={reason}
            onChange={(value) => setReason(value)}
            testId="reason-for-access"
            showTopSection
            required
          />

          <HyroField
            minRows={3}
            maxRows={3}
            value={context}
            label={LABELS.CONTEXT}
            placeholder={PLACEHOLDERS.ADD_CONTEXT}
            helperText={
              <Typography component="span" variant="helper-text" display="flex" justifyContent="flex-end">
                {context?.length ?? 0} / {MAX_CONTEXT_LENGTH}
              </Typography>
            }
            inputProps={{ autoComplete: "off", maxLength: MAX_CONTEXT_LENGTH }}
            onChange={(value) => {
              if (value.length <= MAX_CONTEXT_LENGTH) {
                setContext(value);
              }
            }}
            showErrorMessage={false}
            showTopSection
            fullWidth
            isMultiLine
          />
        </Stack>
      </HyroDialog>

      <HyroFeedbackMessage
        message={feedbackConfig.message}
        severity={feedbackConfig.severity}
        showFeedback={feedbackConfig.show}
        closeFeedback={() => setFeedbackConfig({ ...feedbackConfig, show: false })}
      />
    </>
  );
};

export default RequestAccessDialog;

